import { inject } from '@angular/core';
import {
  HttpClient,
  HttpContext,
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { haalAanvraagUitBody, wedstrijdSidUitAntwoord } from '../helpers/club-aanvraag';
import { NO_ERROR_TOKEN } from './error.interceptor';

const SCHRIJVEN = ['POST', 'PUT', 'PATCH'];

/**
 * Een gekozen clubaanvraag (`aanvraag:<id>`, helpers/club-aanvraag.ts) is
 * geen clubalbum. Deze interceptor haalt hem uit elke schrijfaanroep naar
 * arch (wedstrijd, planning, opname) voordat hij vertrekt: de wedstrijd
 * wordt zonder uitclub opgeslagen. Na een geslaagd antwoord koppelt hij de
 * opgeslagen wedstrijd aan de aanvraag, zodat de beheerconsole de uitclub
 * invult zodra de aanvraag is goedgekeurd.
 *
 * Eén plek voor alle formulieren met app-match-home-away, zodat er geen
 * formulier kan zijn dat het vergeet.
 */
export const clubAanvraagInterceptorProvider = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  if (!SCHRIJVEN.includes(request.method) || !request.url.startsWith(environment.apiUrl)) {
    return next(request);
  }

  const uit = haalAanvraagUitBody(request.body);
  if (!uit) {
    return next(request);
  }

  const http = inject(HttpClient);
  return next(request.clone({ body: uit.body })).pipe(
    tap(event => {
      if (!(event instanceof HttpResponse) || !uit.ids.length) {
        return;
      }
      const matchSid = wedstrijdSidUitAntwoord(event.body, uit.plek);
      if (!matchSid) {
        return;
      }
      // Stil: de wedstrijd zelf is opgeslagen. Lukt het koppelen niet, dan
      // ziet de beheerder de aanvraag zonder deze wedstrijd en vult hij hem
      // met de hand in.
      const context = new HttpContext().set(NO_ERROR_TOKEN, true);
      for (const id of uit.ids) {
        http.put(`${environment.authUrl}/ClubRequest/${id}/Match`, { matchSid }, { context })
          .subscribe({ error: () => undefined });
      }
    }),
  );
};
